import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import BM10080View from "../../Views/Bases/BM10080";
import Snackbar from "../../Components/Snackbar";

function BM10080(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [checkInputs, setCheckInputs] = React.useState({
    processCd: "",
    result: false,
  });
  const [saveData, setSaveData] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10080.GetProcess
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getRowData.push({
            processCd: data[i].processCd,
            processNm: data[i].processNm,
            processTime: data[i].processTime,
            createDate: data[i].createDate
              ? Commons.DateFormating(data[i].createDate.toString(), 2)
              : "",
            createId: data[i].createId,
            updateDate: data[i].updateDate
              ? Commons.DateFormating(data[i].updateDate.toString(), 2)
              : "",
            updateId: data[i].updateId,
          });
        }
      });

      setRowData(getRowData);
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CheckKeys = async () => {
    Dialog.ProgressBar(true);

    if (checkInputs.processCd === "") {
      setSnackbars({
        toggle: true,
        type: "info",
        message: "공정코드를 입력해주세요.",
      });
      Dialog.ProgressBar(false);
      return;
    }
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10080.CheckCode,
        {
          processCd: checkInputs.processCd,
        }
      ).then((result) => {
        let data = result.data;

        if (data) {
          setCheckInputs({
            ...checkInputs,
            result: data,
          });
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          setCheckInputs({
            ...checkInputs,
            processCd: "",
          });
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const Print = async (e) => {
    let headerData = [];
    let tableData = [];
    let address;
    //var ItemInfo = itemList.find(f => f.ItemCd == viewModel.DataItem.ItemCd);

    //address = "http://localhost:65061/Bases/Process_BarCode"; //http://localhost:65061/ 114.206.84.134:5540
    address = "https://dongsungprintingmes.com:8082/Bases/Process_BarCode"; //http://localhost:65061/ 114.206.84.134:5540
    headerData.push({
      ReportTitle: "공정 바코드",
      ProcessCd1: selectedRowData[0] ? selectedRowData[0].processCd : "",
      ProcessCd2: selectedRowData[1] ? selectedRowData[1].processCd : "",
      ProcessCd3: selectedRowData[2] ? selectedRowData[2].processCd : "",
      ProcessCd4: selectedRowData[3] ? selectedRowData[3].processCd : "",
      ProcessCd5: selectedRowData[4] ? selectedRowData[4].processCd : "",
      ProcessCd6: selectedRowData[5] ? selectedRowData[5].processCd : "",
      ProcessCd7: selectedRowData[6] ? selectedRowData[6].processCd : "",
      ProcessCd8: selectedRowData[7] ? selectedRowData[7].processCd : "",
      ProcessCd9: selectedRowData[8] ? selectedRowData[8].processCd : "",
      ProcessCd10: selectedRowData[9] ? selectedRowData[9].processCd : "",
      ProcessCd11: selectedRowData[10] ? selectedRowData[10].processCd : "",
      ProcessCd12: selectedRowData[11] ? selectedRowData[11].processCd : "",

      ProcessNm1: selectedRowData[0] ? selectedRowData[0].processNm : "",
      ProcessNm2: selectedRowData[1] ? selectedRowData[1].processNm : "",
      ProcessNm3: selectedRowData[2] ? selectedRowData[2].processNm : "",
      ProcessNm4: selectedRowData[3] ? selectedRowData[3].processNm : "",
      ProcessNm5: selectedRowData[4] ? selectedRowData[4].processNm : "",
      ProcessNm6: selectedRowData[5] ? selectedRowData[5].processNm : "",
      ProcessNm7: selectedRowData[6] ? selectedRowData[6].processNm : "",
      ProcessNm8: selectedRowData[7] ? selectedRowData[7].processNm : "",
      ProcessNm9: selectedRowData[8] ? selectedRowData[8].processNm : "",
      ProcessNm10: selectedRowData[9] ? selectedRowData[9].processNm : "",
      ProcessNm11: selectedRowData[10] ? selectedRowData[10].processNm : "",
      ProcessNm12: selectedRowData[11] ? selectedRowData[11].processNm : "",
    });
    var f = document.createElement("form");
    f.action = address; //192.168.10.252:8081  //192.168.254.33:8081
    f.method = "POST";
    f.target = "_blank";

    var k = document.createElement("input");
    k.type = "hidden";
    k.name = "headerData";
    k.value = JSON.stringify(headerData);
    f.append(k);

    var l = document.createElement("input");
    l.type = "hidden";
    l.name = "tableData";
    l.value = JSON.stringify(tableData);
    f.append(l);
    document.body.appendChild(f);
    f.submit();
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let tranData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10080.Create,
        updateData.length === 0 ? saveData : updateData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          throw new Error(data.message);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setChangedRowData([]);
    }
  };

  const DeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let tranData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < selectedRowData.length; i++) {
        tranData.push({
          processCd: selectedRowData[i].processCd,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10080.Delete,
        tranData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <BM10080View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        CheckKeys={CheckKeys}
        setSnackbars={setSnackbars}
        setSaveData={setSaveData}
        saveData={saveData}
        Print={Print}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default BM10080;
